import { render, staticRenderFns } from "./TicketListForTest.vue?vue&type=template&id=171d33ca"
import script from "./TicketListForTest.vue?vue&type=script&lang=js"
export * from "./TicketListForTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports